import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { WINE_CATALOG_CONFIG, WINE_CATALOG_TYPE, WineSelectedItems } from './InstancesCatalogWine-types'

const InstancesCatalogWineComponent = () => {
    const [selectedItems, setSelectedItems] = useState<WineSelectedItems>([])

    return (
        <Content title={WINE_CATALOG_TYPE}>
            <Catalog
                type={WINE_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={{}}
                fixedHeader={WINE_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={WINE_CATALOG_CONFIG.isExistRightToolbar}
            />
        </Content>
    )
}

export const InstancesCatalogWine = checkAvailableModule('instancesCatalog/wine') ? InstancesCatalogWineComponent : null
